import { createSlice } from '@reduxjs/toolkit'
import initialState from './state'
import { loginAsync } from './action'
import history from '@/utils/history'


// 使用createSlice方法创建一个slice。每一个slice里面包含了reducer和actions，实现模块化的封装
export const counterSlice = createSlice({
  // 命名空间
  name: 'user',
  // state数据的初始值
  initialState,
  // 定义的action。由于内置了immutable插件，可以直接使用赋值的方式进行数据的改变
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload
    }
  },
  extraReducers: {
    [loginAsync.fulfilled](state, action) {
      console.log(state, action, 'fulfilled',history)
      // state.token = action.payload.tokenInfo.tokenValue
      history.push({ pathname: '/home' })
    },
    [loginAsync.rejected](state, action) {
      console.log(state, action, 'rejected')
    },
  }
})

export const { setToken } = counterSlice.actions


export default counterSlice.reducer